/* 流程配置相关接口 */
import { $post } from '@/api/request'

export function query (data = {}) {
  return $post({
    url: '/baseFlowConfig/query',
    data
  })
}

export function update (data = {}) {
  return $post({
    url: '/baseFlowConfig/update',
    data
  })
}
